import { Col, Row } from "antd";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { mainLink } from "../../Components/Menu/mainLink";
import Menu from "../../Components/Menu/Menu";
import mainRoutes from "./mainRoutes";

const MainRouter = () => {
  return (
    <div className="main">
      <Row>
        <Col span={5}>
          <Menu links={mainLink} />
        </Col>
        <Col className="main_page" span={19}>
          <Routes>
            {mainRoutes.map((route) => (
              <Route
                element={<route.component />}
                path={route.exact ? route.path : `${route.path}/*`}
                key={route.path}
              />
            ))}
          </Routes>
        </Col>
      </Row>
    </div>
  );
};

export default MainRouter;
